export default __webpack_public_path__ + "static/media/1950.78da8689.png";